<template>
    <div class="club-search-bar-wrapper">
        <div class="club-search-bar">
            <input
                v-model="searchInput"
                @change="findClub"
                type="text"
                name="location"
                id="club-search"
                class="club-search-bar-input form-control"
            >
        </div>
    </div>
</template>

<script>

    export default {
        name: 'ClubSearchBar',
        props: {
            clubs: {
                type: Array,
                default: () => [],
            },
        },
        data() {
            return {
                searchInput: '',
            };
        },
        methods: {
            findClub() {
                const club = this.clubs
                    .find(item => item.title.toLowerCase()
                        .includes(this.searchInput.toLowerCase()));

                eventHub.$emit('resetCurrent');

                if (club) {
                    eventHub.$emit('scrollToActive', club.id);
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .club-search-bar {
        &-wrapper {
            flex: 1 1 auto;
        }

        &-input {
            width: 100%;
            max-width: 478px;
            height: 56px;
            padding: 0 24px;
            background-color: #fff;
            border-radius: 5px;
        }
    }
</style>
